import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';
@Component({
  selector: 'app-career-options-after-bachelor-of-commerce',
  templateUrl: './career-options-after-bachelor-of-commerce.component.html',
  styleUrls: ['./career-options-after-bachelor-of-commerce.component.scss']
})
export class CareerOptionsAfterBachelorOfCommerceComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;

  ngOnInit(): void {
  }

}
